
import Vue from 'vue';
import { Component, Inject, Prop, Watch } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Toasted from 'vue-toasted';
import Datepicker from 'vuejs-datepicker';
import { de } from 'vuejs-datepicker/dist/locale';
import { WindowType } from '../../../util';
import { PqtConfig, PqtProduct, PqtProductTest, SettingsApiControllerUIClient } from '../../backend/backendapi';
import { FileStatusMessage, StatusMessage } from '../../dropzone/dropzone.util';
import { productNumber } from '../util';
import { initClient } from '../../../api';
import State from '../State';
import PqtMeasurements from './PqtMeasurements';
import DropZone from '../../dropzone/DropZone';
import configHidden from '../../../directives/configHidden';
import configRequired from '../../../directives/configRequired';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    Datepicker,
    DropZone,
    PqtMeasurements,
    vSelect,
    ImageViewer: require('../../imageviewer/imageviewer.vue.html').default,
  },
  directives: {
    configHidden,
    configRequired,
  },
})
export default class PqtProductTestEdit extends Vue {
  @Prop({ required: true })
  product!: PqtProduct;
  @Prop({ required: true })
  test!: PqtProductTest;
  @Prop({ default: true })
  editable!: boolean;

  @Inject({ from: 'state' })
  readonly state!: State;

  private readonly settingsApi = initClient(SettingsApiControllerUIClient);
  datepickerDE: any = de;
  weightUnits: string[] = [];

  get allowMediaDelete(): boolean {
    return window.application.permissions.productQualityTests.mediaDelete;
  }

  get productNumber(): string {
    return productNumber(this.product, this.state.groupsStore.groupTypes);
  }

  mounted(): void {
    this.reloadWeightUnits();
  }

  fileUploaded(status: FileStatusMessage): void {
    if (status.type !== StatusMessage.success) {
      return;
    }
    this.$emit('fileAdded', status.fileId);
  }

  makeConfig(key: string): { config: PqtConfig, key: string } {
    return { config: this.state.config, key };
  }

  async reloadWeightUnits(): Promise<void> {
    try {
      let units = (await this.settingsApi.getSystemSetting('productQualityTests.weightUnits')).result as string [];
      if (!Array.isArray(units)) { //api return {} if no setting found
        units = [];
      }
      this.weightUnits = units;
    } catch (e) {
      console.error('Failed to load weight units', e);
      this.weightUnits = [];
    }
  }

  removeMedia(mediaId: string): void {
    console.log('rem', mediaId);
    let index = this.test.files.findIndex(e => e.id === mediaId);
    if (index > -1) {
      this.test.files.splice(index, 1);
    }
  }

  @Watch('test.measurementSpecifications', { immediate: true })
  onTestMeasurementSpecifications(): void {
    if (this.test.measurementSpecifications?.length && !this.test.error) {
      this.test.error = 'n/a';
    }
  }
}
